// ============================================================================
// PRODUCT ENDPOINTS
// ============================================================================
// BASE_PATH must match the backend controller route token (ProductController → /Product).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const PRODUCT_BASE_PATH = '/Product';

export const productEndpoints = {
  list: () => buildEndpoint(PRODUCT_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${PRODUCT_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${PRODUCT_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(PRODUCT_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${PRODUCT_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${PRODUCT_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${PRODUCT_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default productEndpoints;
